export default __webpack_public_path__ + "static/MIPs-bca44412ad81ee169ce94b737728f2a2.png";